export default {
  props: {
    col: {
      type: Object,
      required: true
    },

    item: {
      required: true
    },

    index: {
      type: Number,
      required: true
    },
  },

  computed: {
    value() {
      const col = this.col;

      if (col.value === undefined) {
        // throw Error("Bad column: missing 'value': " + JSON.stringify(col));
        return this.item;
      }

      return this.resolveFn(col.value, this.item, this.index);
    }
  },

  methods: {
    resolveFn(fn, ...args) {
      if (typeof fn === 'function') {
        return fn(...args);
      }

      return fn;
    }
  }
};
